import { RequestDraftStatus } from '@prisma/client';

import { Draft } from '../../components/RequestDrafts/types';
import { trpc, TrpcOutputs } from '../../config/trpc';

export type ApplyPlan = TrpcOutputs['getRequestDraftApplyPlan'];

/**
 * What Apply would do to this draft RIGHT NOW — recomputed server-side against the quote's current legs, so the preview
 * cannot promise a fill that a human's manual entry has since made impossible. Only fetched while the draft is still
 * applicable; an applied or discarded draft renders from its stored applied_summary instead.
 */
export const useApplyPlan = (draft: Draft | undefined): ApplyPlan | undefined => {
  const enabled = !!draft && draft.status === RequestDraftStatus.Pending && !draft.applied_at;
  const { data } = trpc.getRequestDraftApplyPlan.useQuery({ id: draft?.id as number }, { enabled });
  return enabled ? data : undefined;
};
